import { render, staticRenderFns } from "./chooseGoodsPlatFormCategory.vue?vue&type=template&id=4d7cb5d6"
import script from "./chooseGoodsPlatFormCategory.vue?vue&type=script&lang=js"
export * from "./chooseGoodsPlatFormCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports